import { useStaticDataTypeLabelList } from '@/features/logs-management/static-data-type/staticDataTypeName/hooks/useStaticDataTypeLabelList';
import { StaticDataTypeLabelTable } from '@/features/logs-management/static-data-type/staticDataTypeName/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortStaticDataLabelSchema = z.object({
  id: z.enum(['staticDataLabel', 'staticDataDescription']),
  desc: z.boolean(),
});

const staticDataLabelSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortStaticDataLabelSchema))
    .optional(),
  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
  staticDataTypeId: z.coerce.string().optional(),
});

export const Route = createFileRoute('/(app)/logs-management/static-data-type/$staticDataTypeName/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => staticDataLabelSchema.parse(search),
});

function RouteComponent() {
  const { staticDataTypeLabel, isLoading, pagination } = useStaticDataTypeLabelList();
  return <StaticDataTypeLabelTable data={staticDataTypeLabel} isLoading={isLoading} pagination={pagination} />;
}
